import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import HomePage from './pages/HomePage';
import ProfilePage from './pages/ProfilePage';
import HSEQPage from './pages/HSEQPage';
import FleetPage from './pages/FleetPage';
import ProjectsPage from './pages/ProjectsPage';
import CareersPage from './pages/CareersPage';
import ContactPage from './pages/ContactPage';
import './App.css';

const AppLayout: React.FC = () => {
  const location = useLocation();
  // The fixed header floats over the home hero; other pages need an offset.
  const needsHeaderOffset = location.pathname !== '/';

  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className={`flex-1 ${needsHeaderOffset ? 'pt-24' : ''}`}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/hse-q" element={<HSEQPage />} />
          <Route path="/fleet" element={<FleetPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;